module.exports = __webpack_public_path__ + "static/media/Formular-Light.be7c7101.ttf";